import { render } from "./subInsureBetList.vue?vue&type=template&id=1b5d2851&scoped=true"
import script from "./subInsureBetList.vue?vue&type=script&lang=js"
export * from "./subInsureBetList.vue?vue&type=script&lang=js"

import "./subInsureBetList.vue?vue&type=style&index=0&id=1b5d2851&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5d2851"]])

export default __exports__